import { type Enum } from '@webapp/infrastructure/types/Enum'

export const UnbilledItemsPageStatuses = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
} as const
export type UnbilledItemsPageStatusEnum = Enum<typeof UnbilledItemsPageStatuses>

export interface UnbilledItemsPageParams {
  status: UnbilledItemsPageStatusEnum | ''
}
